import BatterTableDataView from "@/components/BatterTableDataView.vue";
export default {
  name: "XhsNoteList",
  components: {
    BatterTableDataView
  },
  data() {
    return {
      list: null,
      internalMs: 1200
    };
  },
  methods: {
    onFetchData(l) {
      this.list = l.list;
    },
    freshThisPage() {
      if (!this.list) {
        return;
      }
      let cnt = 0;
      for (let note of this.list) {
        if (note.noteId) {
          setTimeout(() => {
            window.open(`https://www.xiaohongshu.com/explore/${note.noteId}?ICECMD=CLOSE_AFTER_UPDATE`, '_blank');
          }, cnt * this.internalMs);
          cnt += 1;
        }
      }
    },
    look(noteId) {
      window.open('/material/detail/' + noteId, '_blank');
    },
    lookNote(note) {
      window.open(`https://www.xiaohongshu.com/explore/${note.noteId}`, '_blank');
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};